import { Modal } from 'antd';
import React from 'react';
import ListFilePaymentAvailble from './ListFilePaymentAvailble';

export type PFileListModalProps = {
  visible: boolean;
  onChange: (item: any) => void;
  //   onSelect: (item: any) => void;
  onCancel: () => void;
};

const PFileModalPayment = ({
  onChange,
  visible,
  onCancel,
}:
PFileListModalProps) => {
  return (
    (<Modal
      footer=""
      open={visible}
      onCancel={onCancel}
      width={800}
      destroyOnClose
    >
      <ListFilePaymentAvailble onSelect={onChange} />
    </Modal>)
  );
};

export default PFileModalPayment;
